import React from 'react';

export const EmailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.66683 2.6665H13.3335C14.0668 2.6665 14.6668 3.2665 14.6668 3.99984V11.9998C14.6668 12.7332 14.0668 13.3332 13.3335 13.3332H2.66683C1.9335 13.3332 1.3335 12.7332 1.3335 11.9998V3.99984C1.3335 3.2665 1.9335 2.6665 2.66683 2.6665Z" stroke="#443C41" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.6668 4L8.00016 8.66667L1.3335 4" stroke="#443C41" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
